import { createSelector } from 'reselect'

import { rootSelector } from 'utils/redux'

export const inboxes = rootSelector('inboxes')

export const inboxOptions = createSelector(
  inboxes,
  (selectedInboxes) =>
    !!selectedInboxes &&
    selectedInboxes.map((inbox) => ({
      value: inbox.id,
      label: inbox.name ? `${inbox.name} (${inbox.address})` : inbox.address,
    }))
)
